module.exports = __webpack_public_path__ + "img/4.7cb5287b.png";